/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   Homepage specific analytics
 */

export const BLOG = 'Blog'
export const CITY = 'City'
export const DOWNLOAD_APP = 'Download App'
export const HOMEPAGE_BOTTOM_SEARCH = 'Bottom Search'
export const HOMEPAGE_MAIN_SEARCH = 'top-search'
export const HOMEPAGE_NAV_SEARCH = 'Nav Search'
export const LANDLORDS = 'Landlords'
export const LISTING_CLICK = 'Listing Click'
export const LISTING_MORE = 'Listing More'
export const LISTING_SORT = 'Listing Sort'
export const PRESS = 'Press'
export const TESTIMONIALS = 'Testimonials'
